import { HttpClient, HttpParams } from "@angular/common/http"
import { Injectable, inject } from "@angular/core"
import { environment } from "src/environments/environment"
import { Observable } from "rxjs"
import { Availability } from "../meta/Availabilty.interface"
import { OrderPayload } from "../meta/OrderPayload.type"

@Injectable({
  providedIn: "root"
})
export class ApiService {
  private readonly httpClient = inject(HttpClient)

  private getUrl(url: string): string {
    return [environment.apiUrl, url].join("/")
  }

  public fetchPostalCodes(): Observable<string[]> {
    return this.httpClient.get<string[]>(this.getUrl("addresses/postalCodes"))
  }

  public fetchCities(postalCode: string): Observable<string[]> {
    const params = new HttpParams().set("postalCode", postalCode)
    return this.httpClient.get<string[]>(this.getUrl("addresses/cities"), {
      params
    })
  }

  public fetchStreetNames(postalCode: string, city: string): Observable<string[]> {
    const params = new HttpParams().set("postalCode", postalCode).set("city", city)
    return this.httpClient.get<string[]>(this.getUrl("addresses/streetNames"), {
      params
    })
  }

  public fetchStreetNumbers(postalCode: string, city: string, streetName: string): Observable<string[]> {
    const params = new HttpParams().set("postalCode", postalCode).set("city", city).set("streetName", streetName)
    return this.httpClient.get<string[]>(this.getUrl("addresses/streetNumbers"), { params })
  }

  public fetchAvailability(
    postalCode: string,
    city: string,
    streetName: string,
    streetNumber: string
  ): Observable<Availability> {
    const params = new HttpParams()
      .set("postalCode", postalCode)
      .set("city", city)
      .set("streetName", streetName)
      .set("streetNumber", streetNumber)
      .set("consumerType", "Business")
    return this.httpClient.get<Availability>(this.getUrl("availability"), {
      params
    })
  }

  public postOrder(payload: OrderPayload, orderNumber: string): Observable<any> {
    return this.httpClient.post<any>(this.getUrl("orders"), { ...payload, orderNumber })
  }

  public generateVzf(payload: OrderPayload, orderNumber: string): Observable<any> {
    return this.httpClient.post<any>(this.getUrl("documents/vzf"), { ...payload, orderNumber }, { responseType: "blob" as "json" })
  }

  public fetchAddress(addressId: number): Observable<any> {
    const params = new HttpParams()
    .set("addressId", addressId)
    return this.httpClient.get<any>(this.getUrl(`addresses/${addressId}`))
  }

}
